import { h, clear } from "../ui/dom";

export interface TutorialStep {
  title: string;
  body: string;
  /** Called each tick; return true to advance. If absent the user taps "Got it". */
  check?: () => boolean;
}

export class TutorialRunner {
  private host: HTMLElement;
  private stepEl?: HTMLElement;
  private idx = 0;
  private ticker?: number;

  constructor(private readonly root: HTMLElement, private readonly steps: TutorialStep[]) {
    this.host = h("div", {}, []);
    root.appendChild(this.host);
  }

  start() {
    if (this.steps.length === 0) return;
    this.renderStep();
    this.ticker = window.setInterval(() => {
      const s = this.steps[this.idx];
      if (s?.check && s.check()) this.advance();
    }, 250);
  }

  private renderStep() {
    clear(this.host);
    const s = this.steps[this.idx];
    if (!s) return;
    this.stepEl = h("div", { class: "tutorial panel" }, [
      h("div", { class: "step-title" }, [`Step ${this.idx + 1} / ${this.steps.length}`]),
      h("div", {}, [s.title]),
      h("div", { class: "muted", style: "margin-top:6px" }, [s.body]),
      h("div", { class: "step-actions" }, [
        h("button", { class: "btn", onclick: () => this.skip() }, ["Skip"]),
        h("button", { class: "btn primary", onclick: () => this.advance() }, ["Got it"]),
      ]),
    ]);
    this.host.appendChild(this.stepEl);
  }

  advance() {
    this.idx++;
    if (this.idx >= this.steps.length) {
      this.dispose();
      return;
    }
    this.renderStep();
  }

  skip() {
    this.dispose();
  }

  dispose() {
    if (this.ticker) window.clearInterval(this.ticker);
    this.host.remove();
  }
}
